import { render, staticRenderFns } from "./Civility.vue?vue&type=template&id=5148fe66"
import script from "./Civility.vue?vue&type=script&lang=ts"
export * from "./Civility.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports